import React, { useState } from "react";
import { SvgComponent as OsakaHeeling } from "./OsakaHeelings";
import { SvgComponent as OsakaFA } from "./OsakaFA";
import { SvgComponent as OsakaBoxPort } from './OsakaBoxPort';
import { SvgComponent as OsakaBoxStbd } from "./OsakaBoxStbd";
import { SvgComponent as OsakaFlinders } from "./OsakaFlinders";
import { SvgComponent as OsakaAth } from "./OsakaAth";

export const OsakaContainer = () => {

    const changeCircleColor = (e, value) => {

        switch (value) {
            case 1:
                e.target.style.fill = '#e62e1e'
                break;

            case 2:
                e.target.style.fill = '#531ee6'
                break;

            default:
                e.target.style.fill = '#fff'
                break;
        }
    }

    const changePlateColor = (e, value) => {
        switch (value) {
            case 1:
                e.target.style.fill = '#000'
                break;

            default:
                e.target.style.fill = '#fff'
                break;
        }
    }

    const handlePlate = (e) => {
        let value = Number(e.target.getAttribute('data-value'))

        if (!value) e.target.setAttribute('data-value', 0)

        value === 1 ? value = 0 : value++

        e.target.setAttribute('data-value', value)

        changePlateColor(e, value)
    }

    const handleCircle = (e) => {
        let value = Number(e.target.getAttribute('data-value'))

        if (!value) e.target.setAttribute('data-value', 0)

        value === 2 ? value = 0 : value++

        e.target.setAttribute('data-value', value)

        changeCircleColor(e, value)
    }

    const [flip, setFlip] = useState(false);

    return (
        <div className="OsakaNunotani">
            <OsakaFA title="Fore and After Magnets" handleCircle={handleCircle} className='compassSvg foreAfter' />
            <OsakaAth title='Athwartships' handleCircle={handleCircle} className='compassSvg ath' />
            <OsakaHeeling title="Heelings" className='compassSvg heelings' />
            <OsakaFlinders title='Flinders' handlePlate={handlePlate} className='compassSvg flinders' />
            <div style={styles.cont}>
                <label style={styles.label} htmlFor="flip">Flip boxes scale</label>
                <input style={styles.input} type="checkbox" checked={flip} name="flip" id=""
                    onChange={(e) => setFlip(!flip)} />
            </div>
            <OsakaBoxPort flip={flip} title='PORTBOARD MAGNETS' handlePlate={handlePlate} className='compassSvg boxes' />
            <OsakaBoxStbd flip={flip} title='STARBOARD MAGNETS' handlePlate={handlePlate} className='compassSvg boxes' />
        </div>
    )
}

const styles = {
    cont:{
        display: "flex",
        alignItems: "center"
    },
    label: {
        fontSize: 22,
        fontWeight: "bold"
    },
    input: {
        appearance: "auto",
        marginLeft: 5,
    }
}

